import { Dialog, Kbd } from "@dfws/ui";
import { SHORTCUTS, type ShortcutDef } from "./shortcuts";
import s from "./Cheatsheet.module.css";

const GROUPS: ShortcutDef["group"][] = ["Application", "Navigation", "Mail"];

export function Cheatsheet({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const all = Object.values(SHORTCUTS) as ShortcutDef[];
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Keyboard shortcuts" size="lg">
      <div className={s.grid}>
        {GROUPS.map((g) => (
          <section key={g} className={s.group}>
            <h3 className={s.heading}>{g}</h3>
            <dl className={s.list}>
              {all
                .filter((d) => d.group === g)
                .map((d) => (
                  <div key={d.keys} className={s.row}>
                    <dt>{d.label}</dt>
                    <dd className={s.keys}>
                      {d.display.map((k, i) => (
                        <span key={k + i} className={s.keyWrap}>
                          {i > 0 && d.keys.includes(" ") && <span className={s.then}>then</span>}
                          <Kbd>{k}</Kbd>
                        </span>
                      ))}
                    </dd>
                  </div>
                ))}
            </dl>
          </section>
        ))}
      </div>
      <p className={s.note}>More shortcuts arrive with each phase: reply and archive in Phase 3 and 4.</p>
    </Dialog>
  );
}
